<template>
  <nav class="menu_navigator" :class="{'bg': background}">
    <div class="menu_wrap statv_wrapper">
      <div class="menu_logo">
        <div class="logo_img" @click="$router.push('/').catch(()=>{})"></div>
        <div class="menu_group" @click.prevent="slideMenu"></div>
      </div>
      <div class="menu_item_group">
        <div class="menu_item" v-for="(menu, idx) in menulist" :key="idx">
          <router-link :to="menu.path" :class="{'active': activeMenu(menu.path)}">
              {{menu.name}} 
          </router-link>
        </div>
      </div>
    </div>

    <!-- Moblie menu -->
    <transition name="m_silder">
      <div v-show="silder" class="slider_wrap">
        <div class="menu_slider">
          <div class="cancel_btn_group" @click.prevent="slideMenu">
            <span class="cancel_btn"></span>
          </div> 
          <div class="m_menu_item_group">
            <div class="m_menu_item" v-for="(menu, idx) in menulist" :key="idx">
              <router-link :to="menu.path" :class="{'active': activeMenu(menu.path)}">
                  {{menu.name}} 
              </router-link>
            </div>
          </div>
          <div class="m_menu_bottom">
            <!-- <div class="m_menu_sns_btn_group">
              <img src="~@/assets/image/footer/youtube_logo_menu_m.png" class="sns_btn yt" alt="youtube" @click.prevent="location('yt')"/>
              <img src="~@/assets/image/footer/insta_logo_menu_m.png" class="sns_btn is" alt="instagram" @click.prevent="location('is')"/>
              <img src="~@/assets/image/footer/navertv_logo_menu_m.png" class="sns_btn na" alt="naver" @click.prevent="location('na')"/>
            </div> -->
            <div class="m_menu_sub_link_group">
              <div class="sub_link" 
                  v-for="(link, idx) in links" 
                  :key="`sub_menu_${idx}`">
                <a :href="link.path" :class="{active: currentPage == link.path}" > {{link.name}} </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div v-show="silder" class="m_menu_wrap"></div>
  </nav>
</template>
<script>
import {MENU} from "@/defs/menu.js"
import _ from "lodash";
import Utils from "@/helpers/utils";

export default {
  name: "Header",
  components: {

  },
  data() {
    return {
      menulist : [],
      background: false,
      silder: false,
      links: [
        {name: "광고문의", path: "/advertise"},
        {name: "사업제휴문의", path: "/contact"},
        {name: "오시는 길", path: "/location"},
      ],
      currentPage: null,
    }
  },
  created() {
    if(!_.eq(this.$route.path,"/")) {
      this.background = true;
    }
    this.getMenuList();
  },
  mounted() {
    this.checkActive(this.$route.path);
  },
  methods: {
    activeMenu(path) {
      const activeNoCheckPath = ['/', '/advertise', '/contact', '/location']

      if (activeNoCheckPath.includes(this.$route.path)) {
        return true
      }

      if (path === this.$route.path) {
        return true
      }

      return false
    },
    getMenuList() {
      // convert obj to array
      let arr = new Array();
      _.forEach(MENU, ((v) => { 
        if(!_.isEqual(v.path, "/")) {
          arr.push(v);
        }
      }));
      this.menulist = arr;
    },
    slideMenu(e) {
      this.silder = !this.silder;
    },
    location(type) {
      let link = Utils.getSns()[type];
      window.open(link,'_blank');
    },
     move(path) {
      this.$router.replace(`${path}`).catch(()=>{})
	  },
    checkActive(path) {
			if(_.some(this.links, {path: path})) {
				this.currentPage = path
			} else {
				this.currentPage = null
			}
		}
  },
  watch : {
    '$route'(to, from) {
      if(!_.isEqual(to.path, from.path)) {
        this.silder = false;
      }
      if(_.isEqual(to.path, "/")) {
        this.background = false;
      } else {
        this.background = true;
      }

      this.checkActive(this.$route.path);
    }
  }
}
</script>
<style lang="less">
.menu_navigator {
  position: fixed;
  background-color: #FFFFFF;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 1920px;
  min-width: 1400px;
  margin: auto;
  height: 150px;
  z-index: 101;
  background-image: url("~@/assets/image/home/BG_menu.svg");
  background-size: 1920px 100%;
  background-position: center;
  background-repeat: no-repeat;
  .menu_wrap {
    position: relative;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    .menu_logo {
      display: flex;
      align-items: center;
      flex: 2 0 auto;
      height: 100%;
      .logo_img {
        width: 415.38px;
        height: 75px;
        background-image: url("~@/assets/image/home/SPOTV PLUS_menu.svg");
        background-size : 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        float: left;
      }
      .menu_group {
        display: none;
      }
    }
    .menu_item_group {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1 0 auto;
      .menu_item {
        display: flex;
        flex: 1 0 auto;
        align-items: center;
        justify-content: center;
        a {
          color: #ffffff;
          text-decoration: none;
          font-weight: 600; 
          font-size: 20px;
          letter-spacing: -1px;
          text-align: center;
          transform: skew(0.03deg);
          &.router-link-exact-active,
          &.router-link-active {
  
          }
        }
      } 
    }
  }
  .slider_wrap {
    .menu_slider {
      display: none;
    }
  }
}


//mobile page
.m .menu_navigator {
  background-image: none;
  max-width: 765px;
  min-width: 345px;
  height: 130px !important;
  margin: auto;
  .menu_wrap {
    .menu_logo {
      width: 100%;
      margin: 0;
      justify-content: center;
      .logo_img {
        width: 387.69px;
        height: 70px;
        background-image: url("~@/assets/image/home/SPOTV PLUS_menu.svg");
      }
      .menu_group {
        display: block;
        position: absolute;
        background-image: url("~@/assets/image/home/menu_btn_m.svg");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 50px;
        height: 42px;
        left: 0;
      }
    }
    .menu_item_group {
      display: none;
    }
  }
  .slider_wrap {
    position: absolute;
    top:0;
    display: flex;
    width: 100vw;
    height: 100vh;
    z-index: 3;
    transition: all 0.5s;
    right: 0;
    .menu_slider {
      height: 100%;
      width: 570px;
      background-color: rgba(255,255,255,0.95);
      position: fixed;
      display: flex;
      flex-flow: column wrap;
      .cancel_btn_group {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 130px;
        background-color: rgba(255,255,255,1);
        &::after {
          content: "";
          position: absolute;
          display: block;
          width: 100%;
          height: 4px;
          bottom: 0;
          background: transparent linear-gradient(270deg, #FFB428 0%, #FF8228 50% #FF6400 100%) 0% 0% no-repeat padding-box;
        }
        .cancel_btn {
          position :absolute;
          background-image: url("~@/assets/image/home/cancel_btn_menu_m.png");
          background-size: 100% 100%;
          display: block;
          width: 42px;
          height: 42px;
          left: 30px;
          z-index: 4;
        }
      }
      .m_menu_item_group {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 100px;
        padding-top: 64px;
        padding-bottom: 160px;

        .m_menu_item {
          a {
            position: relative;
            font-weight: bold;
            color: #ff6400;
            opacity: 0.5;
            text-decoration: none;
            
            &::after {
              content: "";
              position: absolute;
              bottom: -10px;
              display: block;
              width: 0;
              height: 6px;
              background-color: #ff6400;
            }
            &.router-link-exact-active,
            &.router-link-active {
              opacity: 1;
              &::after {
                width: 100%;
              }
            }

            &.active {
              opacity: 1;
            }
          }
        }
      }
      .m_menu_bottom {
        padding: 0 30px;
        min-height: 300px;
        display: flex;
        flex: 1 0 200px;
        flex-flow: column wrap;
        justify-content: center;
        .m_menu_sns_btn_group {
          display: flex;
          flex: 1 0 0;
          flex-flow: row wrap;
          justify-content: center;
          align-items: center;
          .sns_btn {
            width: 70px;
            height: 70px;
          }
          .yt, 
          .is {
            margin-right: 45px;
          }
        }
        .m_menu_sub_link_group {
          display: flex;
          flex: 1 0 auto;
          flex-flow: row wrap;
          justify-content: center;
          align-items: flex-start;
          .sub_link {
            flex: 1 0 auto;
            text-align: center;
            font-weight: bold;
            font-size: 22px;
            transform: skew(0.5deg);
            border-right: 2px solid #717171;
            > a {
              color: #717171;
              &.active {
							  color: #ff6400;
						  }
            }
            &:last-child {
                border: none;
            }
          }
        }
      }
    }
  }
  .m_menu_wrap {
    position: fixed;
    display: block;
    top: 0;
    background-color: #000000;
    opacity: 0.5;
    width: 100vw;
    height: 100vh;
    z-index: 2;
  }
}

//main page
.bg.menu_navigator,
.bg > .menu_navigator {
  background: none;
  background-color: #FFFFFF;
  position: fixed;
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 4px;
    background: transparent linear-gradient(90deg, #FFB428 0%, #FF8228 50%, #FF6400 100%) 0% 0% no-repeat padding-box;
    transition: height 0.3s ease-in;
  }
  .menu_wrap {
    padding: 0;
    align-items: center;

    .menu_item_group {
      .menu_item {
        a {
          position: relative;
          font-weight: 900;
          color: #ff6400;
          opacity: 0.5;

          &::after {
            content: "";
            position: absolute;
            bottom: -12px;
            display: block;
            width: 0;
            height: 6px;
            transition: width 0.2s ease-out;
            background-color: #ff6400;
          }
          &.router-link-exact-active,
          &.router-link-active {
            opacity: 1;
            &::after {
              width: 100%;
            } 
          }

          &.active {
            opacity: 1;
          }
        }
      }
    }
  }
  .slider_wrap {
    .menu_slider {
      .m_menu_item_group {
        .m_menu_item {
          a {
            opacity: 0.5;
          }
        }
      }
    }
  }
}

.m_silder-enter-active {
  transition: all 0.2s ease-out;
}

.m_silder-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.m_silder-enter,
.m_silder-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}

</style>